var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedux(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1159_2550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.596 41.388C44.7392 41.1744 46.4 39.3791 46.4 37.1975C46.4 37.1111 46.3976 37.0247 46.3928 36.9383V36.9503C46.28 34.6391 44.3912 32.8079 42.0704 32.7839H41.9144C39.5912 32.8703 37.7408 34.7735 37.7408 37.1087C37.7408 37.1615 37.7408 37.2144 37.7432 37.2696V37.2624C37.8056 38.3975 38.2712 39.4152 38.996 40.1832L38.9936 40.1808C36.1448 45.4944 31.7912 49.6848 26.504 52.2552L26.3384 52.3272C23.4776 53.9111 20.0648 54.8424 16.4336 54.8424C15.5144 54.8424 14.6072 54.7824 13.7216 54.6672L13.8272 54.6792C10.5608 54.3648 7.74797 52.6536 5.96237 50.1576L5.94077 50.124C4.65197 48.312 3.88157 46.056 3.88157 43.6175C3.88157 41.6087 4.40477 39.7224 5.32397 38.0856L5.29517 38.1431C6.60797 35.6567 8.39837 33.588 10.5608 31.9944L10.6112 31.9608C10.2008 30.8736 9.83357 29.5631 9.57437 28.2167L9.54797 28.0583C-1.69123 36.096 -0.551227 47.0903 2.86157 52.2863C5.84477 56.0927 10.4432 58.5168 15.608 58.5168C15.8432 58.5168 16.076 58.5119 16.3088 58.5023H16.2752C16.3592 58.5047 16.46 58.5048 16.5608 58.5048C18.1136 58.5048 19.6232 58.3247 21.0728 57.9863L20.9384 58.0128C30.5576 56.2512 38.4344 50.052 42.476 41.6592L42.5528 41.4816L42.596 41.388Z",
    fill: "url(#paint0_linear_1159_2550)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1316 31.9176C50.3644 25.3416 41.9476 21.2136 32.5636 21.2136C32.278 21.2136 31.99 21.2184 31.7068 21.2256H31.75H30.4588C29.7796 19.8648 28.3948 18.9456 26.7964 18.9456C26.7484 18.9456 26.7028 18.9456 26.6548 18.948H26.662H26.5684C24.25 18.9816 22.3828 20.868 22.3828 23.1912C22.3828 23.2608 22.3852 23.328 22.3876 23.3952V23.3856C22.4956 25.6968 24.3844 27.5328 26.7076 27.5568H26.8972C28.6108 27.4896 30.058 26.424 30.682 24.9312L30.6916 24.9024H32.0956C38.2252 24.9096 43.9132 26.7912 48.6172 30.0096L48.5164 29.9448C52.1908 32.2968 55.0276 35.676 56.6572 39.6768L56.7076 39.816C57.3316 41.1168 57.694 42.6432 57.694 44.2536C57.694 45.9576 57.2884 47.5656 56.566 48.9864L56.5924 48.9264C54.7276 52.7328 50.8828 55.3056 46.438 55.3056C46.2748 55.3056 46.114 55.3032 45.9532 55.296H45.9772C43.2484 55.2384 40.6732 54.6384 38.338 53.5992L38.4628 53.6496C37.5532 54.408 36.0364 55.656 34.9348 56.4168C37.8484 57.8472 41.266 58.7184 44.878 58.8024H44.9068C45.0484 58.8072 45.214 58.8096 45.3796 58.8096C51.5044 58.8096 56.8684 55.5576 59.842 50.688L59.8852 50.6136C60.706 48.6672 61.1812 46.4064 61.1812 44.0328C61.1812 39.2808 59.2708 34.9752 56.1772 31.8432L56.1796 31.8456L56.1436 31.9224L56.1316 31.9176Z",
    fill: "url(#paint1_linear_1159_2550)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9274 42.7584C17.033 45.072 18.9266 46.9128 21.2546 46.9296H21.4082C23.7314 46.8504 25.5866 44.9448 25.5866 42.6096C25.5866 40.2336 23.669 38.304 21.2954 38.2872H21.1346C21.1106 38.2848 21.0818 38.2848 21.0554 38.2848C20.8802 38.2848 20.7122 38.3112 20.5538 38.364L20.5658 38.3616C17.9978 34.1832 16.4786 29.1216 16.4786 23.7048C16.4786 22.8312 16.517 21.9672 16.5962 21.1152L16.589 21.2256C16.8074 16.6512 18.4874 12.5064 21.1658 9.20875L21.137 9.24715C23.5154 6.67675 26.8658 5.03995 30.6026 4.91995H30.6242C38.813 4.76635 42.2282 14.9712 42.4922 19.0272L46.289 20.1624C45.4058 7.72795 37.673 1.19995 30.2786 1.19995C22.7618 1.59115 16.5242 6.64795 14.3858 13.5144L14.3522 13.6392C13.301 16.668 12.6914 20.1576 12.6914 23.7888C12.6914 30 14.4698 35.796 17.5418 40.6944L17.465 40.5624C17.1218 41.0807 16.9178 41.7168 16.9178 42.4008C16.9178 42.528 16.925 42.6528 16.9394 42.7752L16.937 42.7607L16.9274 42.7584Z",
    fill: "url(#paint2_linear_1159_2550)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1159_2550",
    x1: 0.503906,
    y1: 43.2875,
    x2: 46.4,
    y2: 43.2875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1159_2550",
    x1: 22.3828,
    y1: 38.8776,
    x2: 61.1812,
    y2: 38.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1159_2550",
    x1: 12.6914,
    y1: 24.0648,
    x2: 46.289,
    y2: 24.0648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1159_2550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/redux.94d0ee48de86541cc691143f4ed18292.svg";
export { ForwardRef as ReactComponent };